import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/flat-rates/",
)({
  beforeLoad: () => {
    throw redirect({ to: "/templates/quotes", replace: true })
  },
})
